<i18n src='@/locale/department-localization.json'></i18n>


<template>
    <v-container>
        <v-data-table
            dense
            :headers="headers"
            :options.sync="options"
            :items="gridData"
            :server-items-length="gridDataTotalCount"
            class="elevation-1"
            :footer-props="footerProps"
            @click:row="HandleRowClick"
        >
            <template v-slot:top>
                <!--ფორმა-->
                <v-toolbar flat color="white" v-if="!onlySelect">
                    <v-toolbar-title>{{ $t('Department') }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical> </v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-wm-department-edit-dialog
                    :formTitle="formTitle"
                    :item="item"
                    :new-item="editedIndex == -1"
                    v-if="dialogVis"
                    @cancel="Close"
                    @save="
                        Close();
                        ReloadGrid();
                    "
                ></v-wm-department-edit-dialog>
            </template>
            <template v-slot:header.name="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="filter.name"
                    @change="FilterUpdate"
                    :label="header.text"
                    class="mt-3"
                    prepend-inner-icon="search"
                ></v-text-field>
            </template>
            <template v-slot:header.code="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="filter.code"
                    @change="FilterUpdate"
                    :label="header.text"
                    class="mt-3"
                    prepend-inner-icon="search"
                ></v-text-field>
            </template>
            <template v-slot:header.branch_code="{ header }">
                <v-wm-organization-select
                    parent-branch
                    v-model="filter.branch_code"
                    :label="header.text"
                    @input="FilterUpdate"
                ></v-wm-organization-select>
            </template>
            <template v-slot:header.actions="{ header }">
                <v-btn
                    color="primary"
                    fab
                    small
                    depressed
                    @click="dialogVis = true"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <template v-slot:item.ehr_section="{ item }">
                {{ ehrSectionDisplay(item) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="EditItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="DeleteItem(item)">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="ReloadGrid">Reset</v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import departmentService from '@/service/department-service';
import VWmOrganizationSelect from '@/component/organization-select.vue';
import ehrSectionItems from '@/script/department/ehr-section-items';
import VWmDepartmentEditDialog from '@/component/department/edit-dialog.vue';

import { swalConfirm } from '@/script/common';

export default {
    components: {
        VWmDepartmentEditDialog,
        VWmOrganizationSelect,
    },
    props: {
        value: Number,
        onlySelect: Boolean,
        parentCode: Number,
        parentCodeOrZero: Number,
        includeDeleted: Boolean,
        hasDepartmentAccessWithType: Number,
        hasWard: Boolean,
    },
    created() {
        this.ReloadGrid()
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            dialogVis: false,
            dialogDeleteVis: false,

            filter: {
                code: null,
                branch_code: null,
                name: null,
            },
            gridData: [],
            gridDataTotalCount: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            editedIndex: -1,
            item: {
                code: null,
                branch_code: null,
                name: null,
                r: null,
                ehr_section: null,
                forHR: false,
                forSupply: false,
                forResearch: false,
                forDiagnosis: false,
                forLaying: false,
            },
            defaultItem: {
                code: null,
                branch_code: null,
                name: null,
                r: null,
                ehr_section: null,
                forHR: false,
                forSupply: false,
                forResearch: false,
                forDiagnosis: false,
                forLaying: false,
            },
        };
    },
    computed: {
        headers() {
            var headers = [
                {
                    text: this.$t('Department'),
                    value: 'name',
                    sortable: false,
                    align: 'start',
                },
                { text: this.$t('Dep_Code'), value: 'code', sortable: false },
                {
                    text: this.$t('Dep_Branch'),
                    value: 'branch_code',
                    sortable: false,
                },
                { text: this.$t('Dep_R'), value: 'r', sortable: false },
                {
                    text: this.$t('EhrSection'),
                    value: 'ehr_section',
                    sortable: false,
                },
                { text: '', value: 'actions', sortable: false },
            ];
            if (this.onlySelect) {
                headers.pop();
            }
            return headers;
        },
        params(nv) {
            return {
                ...this.options,
            };
        },
        formTitle() {
            return this.editedIndex === -1
                ? this.$t('Dep_Add')
                : this.$t('Dep_Edit');
        },
    },
    watch: {
        dialogVis(val) {
            val || this.Close();
        },
        'options.page'() {
            this.ReloadGrid();
        },
        'options.itemsPerPage'() {
            this.ReloadGrid();
        },
    },
    methods: {
        FilterUpdate() {
            if (this.options.page == 1) {
                this.ReloadGrid();
            } else {
                this.options.page = 1;
            }
        },
        
        ReloadGrid() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            departmentService
                .getData(page, itemsPerPage, {
                    ...this.filter,
                    branch_code: this.parentCode || this.filter.branch_code,
                    branch_code_or_zero: this.parentCodeOrZero,
                    include_deleted: this.includeDeleted,
                    hasDepartmentAccessWithType: this.hasDepartmentAccessWithType,
                    hasWard: this.hasWard
                })
                .then((data) => {
                    this.gridData = data.data;
                    this.gridDataTotalCount = data.total;
                });
        },

        EditItem(item) {
            this.editedIndex = this.gridData.indexOf(item);
            this.item = Object.assign({}, item);
            this.dialogVis = true;
        },

        DeleteItem(item) {
            if (item && item.name && item.name[0] != '.') {
                var newItem = Object.assign({}, item);
                newItem.name = '.' + newItem.name;
                swalConfirm
                    .fire({
                        allowEnterKey: true,
                        preConfirm: () => {
                            return departmentService
                                .edit(newItem)
                                .then(() => this.ReloadGrid())
                                .catch(() => {});
                        },
                    })
            }
        },

        Close() {
            this.dialogVis = false;
            this.item = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        },

        HandleRowClick(value) {
            this.$emit('select', value ? value.code : null);
        },

        ehrSectionDisplay(item) {
            if (item) {
                if (item.ehr_section) {
                    let ehrSectionFiltered = ehrSectionItems.filter(
                        (i) => i.value == item.ehr_section
                    );
                    if (ehrSectionFiltered.length > 0) {
                        let ehrSection = ehrSectionFiltered[0];
                        return `[${ehrSection.value}] ${ehrSection.text}`;
                    }
                }
                return item.ehr_section;
            }
            return '';
        },
    },
};
</script>

<style lang='scss' scoped>
</style>